import React, { useState } from 'react'
import './ContactForm.css'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { useMagnetic } from '../../hooks/useMagnetic'
import { trackEvent } from '../../lib/analytics'

const useStyles = makeStyles((theme) => ({
  email: {
    '& > *': {
      marginBottom: theme.spacing(2),
      backgroundColor: 'var(--bg-panel)',
      color: 'var(--text)',
      '&:hover': {
        backgroundColor: 'var(--bg-panel)',
        color: 'var(--text)',
      },
      '&.Mui-focused': {
        backgroundColor: 'var(--bg-panel)',
        color: 'var(--text)',
      },
      '&.MuiFilledInput-underline:before': {
        borderBottom: '2px solid var(--border)',
      },
      '&.MuiFilledInput-underline:after': {
        borderBottom: '2px solid var(--accent-2)',
      },
    },
  },
  message: {
    '& > *': {
      marginBottom: theme.spacing(2),
      backgroundColor: 'var(--bg-panel)',
      color: 'var(--text)',
      '&:hover': {
        backgroundColor: 'var(--bg-panel)',
        color: 'var(--text)',
      },
      '&.Mui-focused': {
        backgroundColor: 'var(--bg-panel)',
        color: 'var(--text)',
      },
      '&.MuiFilledInput-underline:before': {
        borderBottom: '2px solid var(--border)',
      },
      '&.MuiFilledInput-underline:after': {
        borderBottom: '2px solid var(--accent-2)',
      },
    },
  },
  submit: {
    '&': {
      backgroundColor: 'var(--accent)',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'var(--accent-2)',
        boxShadow: 'none',
      },
    },
    '& > *': {
      color: 'var(--bg-alt)',
      fontFamily: 'var(--font-body)',
      fontSize: '15px',
      fontWeight: '600',
    },
  },
}))

const ContactForm = () => {
  const [status, setStatus] = useState('')
  const [emailText, setEmailText] = useState('')
  const [messageText, setMessageText] = useState('')

  const classes = useStyles()
  const submitMagnetRef = useMagnetic({ strength: 0.25 })

  const submitForm = (ev) => {
    ev.preventDefault()
    const form = ev.target
    const data = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open(form.method, form.action)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return
      if (xhr.status === 200) {
        setEmailText('')
        setMessageText('')
        form.reset()
        setStatus('SUCCESS')
        trackEvent('contact_form_submit', { status: 'success' })
      } else {
        setStatus('ERROR')
        trackEvent('contact_form_submit', { status: 'error' })
      }
    }
    xhr.send(data)
  }

  const handleEmailChange = (event) => {
    const input = String(event.target.value)
    setEmailText(input)
  }

  const handleMessageChange = (event) => {
    const input = String(event.target.value)
    setMessageText(input)
  }

  return (
    <div className="contact-form-wrapper">
      <form
        className="contact-form"
        onSubmit={submitForm}
        action="https://formspree.io/f/mvoyoqjy"
        method="POST"
      >
        <TextField
          className={classes.email}
          type="email"
          name="email"
          label="Email"
          value={emailText}
          onChange={handleEmailChange}
          variant="filled"
        />
        <TextField
          className={classes.message}
          type="text"
          name="message"
          label="Mensagem"
          value={messageText}
          onChange={handleMessageChange}
          multiline
          rows="5"
          variant="filled"
        />
        {status === 'SUCCESS' ? (
          <p className="email-success">Obrigado!</p>
        ) : (
          <Button
            ref={submitMagnetRef}
            className={classes.submit}
            type="submit"
            variant="contained"
          >
            Enviar
          </Button>
        )}
        {status === 'ERROR' && <p>Ooops! There was an error.</p>}
      </form>
    </div>
  )
}

export default ContactForm
